module.exports = __webpack_public_path__ + "static/media/my-referrals-icon.22ce08e2.svg";